export default __webpack_public_path__ + "4d1e9da53e9b45a4f4640334d03293fd.woff2";